import { render, staticRenderFns } from "./FaqAndSupportChannelsTabContent.vue?vue&type=template&id=a03d8c16&scoped=true"
import script from "./FaqAndSupportChannelsTabContent.vue?vue&type=script&lang=js"
export * from "./FaqAndSupportChannelsTabContent.vue?vue&type=script&lang=js"
import style0 from "./FaqAndSupportChannelsTabContent.vue?vue&type=style&index=0&id=a03d8c16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03d8c16",
  null
  
)

export default component.exports